export default __webpack_public_path__ + "static/media/amountIcon.02e380b9.svg";